import React, { useRef, useState } from 'react';
import { UploadCloud, Loader2 } from 'lucide-react';
import { Action } from '../Common';

export const KnowledgeUpload = ({uploading, onUpload}: {uploading: boolean; onUpload: (file?: File) => Promise<void>}) => {
  const [drag, setDrag] = useState(false);
  const input = useRef<HTMLInputElement>(null);
  const chooseFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    await onUpload(file);
    // Reset even after rejected uploads so the same file can be chosen again.
    if (input.current) input.current.value = '';
  };
  const drop = (event: React.DragEvent) => {
    event.preventDefault(); setDrag(false);
    if (!uploading) void onUpload(event.dataTransfer.files[0]);
  };
  return <div className={`upload-band ${drag ? 'drag-active' : ''}`} onDragOver={event => {event.preventDefault(); setDrag(true);}} onDragLeave={() => setDrag(false)} onDrop={drop}>
    <div className="upload-icon">{uploading ? <Loader2 className="spin" size={27}/> : <UploadCloud size={27} strokeWidth={1.4}/>}</div>
    <div><h2 data-testid="upload-title">{uploading ? 'Adding your knowledge…' : 'Make your expertise part of every reply.'}</h2><p data-testid="upload-formats">Drop a help document here. PDF, DOCX, TXT, or Markdown · Up to 5 MB</p></div>
    <input ref={input} type="file" className="sr-only" data-testid="kb-upload-file-input" aria-label="Upload knowledge document" accept=".pdf,.docx,.txt,.md" onChange={chooseFile} disabled={uploading}/>
    <Action variant="outline" data-testid="kb-upload-doc-button" disabled={uploading} onClick={() => input.current?.click()}><UploadCloud size={15}/>Upload document</Action>
  </div>;
};